const defaultTheme = require("tailwindcss/defaultTheme");

module.exports = {
  content: ["./src/**/*.{js,jsx,ts,tsx,svg}"],
  mode: "jit",
  theme: {
    extend: {
      fontFamily: {
        //You can change this up but we generally use serif for top level heading/primary typeface of most brands. Treat this in terms of nomenclature not function
        primary: ["PPRightGothic", "sans-serif"],

        secondary: ["Manrope", "sans-serif"],
      },

      colors: {
        primary: {
          DEFAULT: "#F9956B",
          100: "#FEEAE1",
          200: "#FDD5C4",
          300: "#FBBFA6",
          400: "#FAAA89",
          500: "#C77756",
          600: "#955940",
          700: "#643C2B",
          800: "#321E15",
        },
        secondary: {
          DEFAULT: "#121212",
          100: "#FFFFFF",
          200: "#FBFBFB",
          300: "#EFEFEF",
          400: "#DDDDDD",
          500: "#C6C6C6",
          600: "#BBBBBB",
          700: "#999999",
          800: "#868686",
          900: "#444444",
          1000: "#1F1F1F",
          1100: "#171616",
          1200: "#000000",
        },
        alternative: {
          DEFAULT: "#F2DC8E",
          100: "#FCF8E8",
          200: "#FAF1D2",
          300: "#F7EABB",
          400: "#F5E3A5",
          500: "#C2B072",
          600: "#918455",
          700: "#615839",
          800: "#302C1C",
        },

        action: {
          success: "#36CC4F",
          error: "#FF0000",
        },
      },

      boxShadow: {
        subMenu: " 0px 4px 100px rgba(41, 45, 50, 0.09)",
      },

      keyframes: {
        scroll: {
          "0%": { transform: "translateX(0)" },
          "100%": { transform: "translateX(-80%)" },
        },
      },
      animation: {
        scroll: "scroll 10s linear infinite",
      },
    },

    screens: {
      xs: "450px",
      ...defaultTheme.screens,
    },
  },
  variants: {
    extend: {},
  },
  plugins: [
    function ({ addVariant }) {
      addVariant("nth-child-even", "&:nth-child(even)");
    },
  ],
};
